import $ from 'cash-dom';
import prequalifySpinner from '../prequalify-spinner';
import PrequalifyModalHandler from './PrequalifyModalHandler';
import QuestionStorageBuilder from '../storage/QuestionStorageBuilder';
import UrlHelper from '../../../../components/UrlHelper';
import PrequalState from '../PrequalState';

class NextQuestionsHandler {
	static handle() {
		let prequalIsShown = false;

		const redirectSourcePageId = UrlHelper.getParam(window.location.href, PrequalState.PARAM_REDIRECT_SOURCE_PAGE);

		if (redirectSourcePageId) {
			UrlHelper.removeParamFromCurrentUrl(PrequalState.PARAM_REDIRECT_SOURCE_PAGE);
		}

		const currentPageId = $('body').data('post-id');
		const questionStorage = QuestionStorageBuilder.buildFromStorageData(
			currentPageId,
			redirectSourcePageId,
			true
		);

		if (questionStorage.isInit()) {
			const prequalifyModalHandler = new PrequalifyModalHandler(questionStorage);
			prequalIsShown = prequalifyModalHandler.handle();
		} else {
			// no data in localStorage for the current page
			prequalifySpinner.hide();
			prequalIsShown = false;
		}

		return prequalIsShown;
	}
}

export default NextQuestionsHandler;
